<template>
  <Layout class="order-tab">
    <Sider hide-trigger :style="{ background: '#fff' }">
      <Menu :active-name="tabOn" theme="light" width="auto" ref="side_menu">
        <MenuItem
          style="text-align: center"
          name="uorder"
          :to="{ name: 'User_My_Order' }"
        >
          我的订单
        </MenuItem>
        <MenuItem
          style="text-align: center"
          name="upresonal"
          :to="{ name: 'UPresonal' }"
        >
          个人信息
        </MenuItem>
         <MenuItem style="text-align: center" name="umyBookOrder" :to="{name:'UMyBookOrder'}">
            我的预约
        </MenuItem>
        <!-- <MenuItem name="/order/connect" :to="{name:'Connect'}">
            联系人
        </MenuItem> -->
        <!-- 香山暂时不要发票 -->
        <MenuItem
          style="text-align: center"
          name="uinvoice"
          :to="{ name: 'UInvoice' }"
        >
          电子发票
        </MenuItem>
      </Menu>
    </Sider>
    <Content
      :style="{ padding: '24px', minHeight: '280px', background: '#fff' }"
    >
      <router-view></router-view>
    </Content>
  </Layout>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      tabOn: "upresonal"
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.path.indexOf("uorder") !== -1) {
      next(vm => {
        vm.tabOn = "uorder";
      });
    } else {
      next();
    }
    // if (to.path.indexOf('presonal') !== -1) {
    //   next(vm => {
    //     vm.tabOn = 'upresonal'
    //   })
    // } else {
    //   next()
    // }
    if (to.path.indexOf("uinvoice") !== -1) {
      next(vm => {
        vm.tabOn = "uinvoice";
      });
    } else {
      next();
    }
  },
 watch: {
    $route (to, from, next) {
      console.log(this.tabOn)
      if(to.name == 'User_My_Order'){
         this.$nextTick(()=>{
            this.tabOn = 'uorder'
            this.$refs.siderMenu.updateActiveName()
         })
      }
      if(to.name == 'UPresonal'){
         this.$nextTick(()=>{
            this.tabOn = 'upresonal'
            this.$refs.siderMenu.updateActiveName()
         })
      }
      if(to.name == 'UInvoice'){
         this.$nextTick(()=>{
            this.tabOn = 'uinvoice'
            this.$refs.siderMenu.updateActiveName()
         })
      }
      if(to.name == 'UMyBookOrder'){
         this.$nextTick(()=>{
            this.tabOn = 'umyBookOrder'
            this.$refs.siderMenu.updateActiveName()
         })
      }
    }
  }
};
</script>

<style>
.order-tab ul {
  height: 100%;
}
</style>
